import { useContext, useEffect } from 'react';
import { AuthContext } from '../../Context';
import { AuthContextApi } from '../../Context/api';
import { Link } from "react-router-dom";
import {
    ExclamationTriangleIcon,
    WrenchScrewdriverIcon,
    DocumentTextIcon
} from '@heroicons/react/24/outline'


const UsuariosIndex = () => {
    const { states, setters } = useContext(AuthContext)
    const { checkLogin } = useContext(AuthContextApi)




    const primeiroLoad = async () => {
        await checkLogin()
    }

    useEffect(() => {
        primeiroLoad()

        return () => {
            primeiroLoad()
        }

    }, [])


    return (
        <>
            {/* Header da Página */}
            <div className="bg-white border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center">
                        <div className="p-2 rounded-lg bg-indigo-100 mr-3">
                            <WrenchScrewdriverIcon className="w-6 h-6 text-indigo-600" />
                        </div>
                        <div>
                            <h1 className="text-2xl font-semibold text-gray-900">
                                Painel Técnico
                            </h1>
                            <p className="text-sm text-gray-600">
                                Acesso às ferramentas técnicas e administrativas do sistema
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conteúdo Principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Cards de Estatísticas - Design Artístico */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                    <div className="relative bg-gradient-to-br from-green-50 via-white to-emerald-50/30 backdrop-blur-sm rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-emerald-500/5"></div>
                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-green-400/10 to-emerald-400/10 rounded-full -translate-y-12 translate-x-12"></div>
                        <div className="relative p-6">
                            <div className="flex items-center justify-between mb-4">
                                <div className="p-3 rounded-2xl bg-gradient-to-r from-green-500 via-emerald-600 to-green-700 shadow-lg">
                                    <ExclamationTriangleIcon className="w-6 h-6 text-white" />
                                </div>
                                <div className="text-right">
                                    <div className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-green-800 to-emerald-800 bg-clip-text text-transparent">
                                        Logs
                                    </div>
                                </div>
                            </div>
                            <h3 className="text-lg font-semibold bg-gradient-to-r from-gray-900 via-green-800 to-emerald-700 bg-clip-text text-transparent">
                                Sistema de Logs
                            </h3>
                        </div>
                    </div>

                    <div className="relative bg-gradient-to-br from-blue-50 via-white to-indigo-50/30 backdrop-blur-sm rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-indigo-500/5"></div>
                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-blue-400/10 to-indigo-400/10 rounded-full -translate-y-12 translate-x-12"></div>
                        <div className="relative p-6">
                            <div className="flex items-center justify-between mb-4">
                                <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-500 via-indigo-600 to-blue-700 shadow-lg">
                                    <DocumentTextIcon className="w-6 h-6 text-white" />
                                </div>
                                <div className="text-right">
                                    <div className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-indigo-800 bg-clip-text text-transparent">
                                        Requests
                                    </div>
                                </div>
                            </div>
                            <h3 className="text-lg font-semibold bg-gradient-to-r from-gray-900 via-blue-800 to-indigo-700 bg-clip-text text-transparent">
                                Requests do Sistema
                            </h3>
                        </div>
                    </div>
                </div>

                {/* Cards de Ferramentas - Design Artístico */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Link
                        to="/tecnicoIndex/logs"
                        className="group relative bg-gradient-to-br from-green-50 via-white to-emerald-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-green-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden"
                    >
                        <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-emerald-500/5"></div>
                        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-green-400/10 to-emerald-400/10 rounded-full -translate-y-16 translate-x-16"></div>

                        <div className="relative p-8">
                            {/* Header do Card */}
                            <div className="flex items-center mb-6">
                                <div className="p-4 rounded-2xl bg-gradient-to-r from-green-500 via-emerald-600 to-green-700 shadow-lg mr-4">
                                    <ExclamationTriangleIcon className="w-8 h-8 text-white" />
                                </div>
                                <div>
                                    <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-green-800 to-emerald-700 bg-clip-text text-transparent">
                                        Sistema de Logs
                                    </h2>
                                    <p className="text-sm text-gray-600 mt-1">
                                        Monitoramento e análise de eventos
                                    </p>
                                </div>
                            </div>

                            {/* Descrição */}
                            <div className="mb-6 p-4 bg-gradient-to-r from-gray-50 to-green-50 rounded-2xl border border-gray-100">
                                <p className="text-gray-700 leading-relaxed">
                                    Acesse os logs do sistema para monitorar eventos, erros e atividades.
                                    Ferramenta essencial para diagnóstico e manutenção.
                                </p>
                            </div>

                            {/* Badge de Status */}
                            <div className="flex items-center justify-between">
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                    Disponível
                                </span>
                                <div className="text-sm text-gray-500 group-hover:text-green-600 transition-colors">
                                    Acessar →
                                </div>
                            </div>
                        </div>
                    </Link>

                    <Link
                        to="/tecnicoIndex/requests"
                        className="group relative bg-gradient-to-br from-blue-50 via-white to-indigo-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-blue-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden"
                    >
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-indigo-500/5"></div>
                        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-400/10 rounded-full -translate-y-16 translate-x-16"></div>

                        <div className="relative p-8">
                            {/* Header do Card */}
                            <div className="flex items-center mb-6">
                                <div className="p-4 rounded-2xl bg-gradient-to-r from-blue-500 via-indigo-600 to-blue-700 shadow-lg mr-4">
                                    <DocumentTextIcon className="w-8 h-8 text-white" />
                                </div>
                                <div>
                                    <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-indigo-700 bg-clip-text text-transparent">
                                        Requests do Sistema
                                    </h2>
                                    <p className="text-sm text-gray-600 mt-1">
                                        Gerenciamento de solicitações
                                    </p>
                                </div>
                            </div>

                            {/* Descrição */}
                            <div className="mb-6 p-4 bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl border border-gray-100">
                                <p className="text-gray-700 leading-relaxed">
                                    Acesse e gerencie as solicitações do sistema.
                                    Controle de requisições e processos administrativos.
                                </p>
                            </div>

                            {/* Badge de Status */}
                            <div className="flex items-center justify-between">
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                                    Disponível
                                </span>
                                <div className="text-sm text-gray-500 group-hover:text-blue-600 transition-colors">
                                    Acessar →
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    )

}



export default UsuariosIndex;